/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../../common/components/layout/Layout';
import Header from '../../../../../common/components/layout/Header';
import PaymentLabels from '../../../../../common/components/modules/sports/PaymentLabelsLeft';

import LayoutInside from '../../../../../common/components/layout/LayoutInside';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addGuestGame, fetchGameById, joinGame } from '../../../../../modules/sport/actions/reducerGame';
import Loading from '../../../../../common/loading/Loading';
import { IGame } from '../../../../../modules/sport/interfaces/game';
import { format } from 'date-fns';
import Msj from '../../../../../common/components/sections/Msj';
import MsjSuccess from '../../../../../common/components/sections/MsjSuccess';
import { attributesBySport } from '../../../../../common/data/attributes';
import { formatPrice } from '../../../../../utils';
import { useAuth } from '../../../../../context/auth-context';
import { createModel } from '../../../../../services/api.service';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const RegistrationConfirmed = (): JSX.Element => {
    const dispatch = useDispatch();
    const auth = useAuth();
    const attribute = attributesBySport('integrate');
    const query = useQuery();
    const [title, setTitle] = useState<string>();
    const gameId = query.get('gameId');
    const guests = query.get('guests');
    const selectGame = (state: any) => state.game;
    const game = useSelector(selectGame);
    const [detGame, setDetGame] = useState<IGame>();
    const [error, setError] = useState('');
    const [total, setTotal] = useState({
        description: '',
        monto: 0,
    });
    const [status, setStatus] = useState(false);
    const [players, setPlayers] = useState(0);
    const [dateMatch, setDateMatch] = useState({ start: '', end: '', date: '', format: '', club: '' });
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const pathnameGames = `/${sport}/integrar/partidos/filter` + useLocation().search;
    const pathnameAll = window.location.pathname + useLocation().search;
    const router = useHistory();
    const [timeGame, setTimeGame] = useState(false);
    const mydate = new Date();
    const [isRedirecting, setIsRedirecting] = useState(false);

    const breads = [
        {
            key: 'integrar',
            name: 'Integrar ',
            url: `/integrar`,
            add: true,
        },
        {
            key: 'partidos',
            name: 'Partidos',
            url: pathnameGames,
            add: false,
        },
        {
            key: 'unirse',
            name: 'Unirse',
            url: `/${sport}/integrar/unirse/filter?gameId=${gameId}`,
            add: false,
        },
        {
            key: 'confirmar',
            name: 'Confirmar',
            url: pathnameAll,
            add: false,
        },
    ];

    useEffect(() => {
        dispatch(fetchGameById(gameId, auth.isLoggedIn));
    }, [gameId]);

    const handlePayment = async (idReservation) => {
        try {
            const response = await createModel('payments/webpay/create')({
                reservationId: idReservation,
            });
            // console.log('aqui response', { response });
            if (response?.data?.url && response?.data?.token) {
                const url = `${response.data.url}?token_ws=${response.data.token}`;
                window.location.href = url;
            }
            setIsRedirecting(false);
        } catch (error) {
            console.log('aqui error');
            console.log({ error });
            setIsRedirecting(false);
            setError('Ocurrio un error, le notificaremos al correo para que pueda realizar el pago correspondiente');
        }
    };

    useEffect(() => {
        if (game) {
            // console.log({ game });
            if (game.error) {
                // console.log('aqui errro:', game.error);
                setError(game.error);
                setStatus(false);
            }
            if (
                (game.data && game.data.statusCode === 'GAME_PLAYER_JOINED') ||
                (game.data && game.data.statusCode === 'GAME_ADD_GUESTS_SUCCESSFULLY')
            ) {
                if (game.data.data.statusGame === 'CONFIRMED' && game.data.data.reservationId && players !== 0) {
                    setIsRedirecting(true);
                    handlePayment(game.data.data.reservationId);
                } else {
                    setStatus(true);
                }
            }

            setDetGame(game.data?.data);
        }
    }, [game]);

    useEffect(() => {
        if (detGame && detGame.alreadyJoined) {
            let valGuest = parseInt(guests);
            //console.log({ valGuest, guestsCount: detGame.guestsCount });
            //const guestsReal = parseInt(guests) - detGame.guestsCount;
            if (valGuest >= detGame.maxCapacity) {
                setError('La cantidad de invitados supera la capacidad maxima del partido');
            }
            if (detGame.alreadyPaid && !detGame.alreadyPending) {
                setPlayers(parseInt(guests) - detGame.guestsCount);
            } else {
                if (valGuest !== 0 && detGame.alreadyPending) {
                    if (valGuest < detGame.guestsCount) {
                        const difValGuest = detGame.guestsCount - parseInt(guests);
                        valGuest = detGame.pendingGuest - difValGuest;
                        //analizo si paidPlayer es cero no a pagado ningun jugador por lo tanto sumo al jugador principal
                        valGuest = detGame.paidPlayer > 0 ? valGuest : valGuest + 1;
                        // console.log('eliminaste un jugador', { difValGuest, valGuest });
                        setPlayers(valGuest);
                    } else {
                        const difValGuestAdd = parseInt(guests) - detGame.guestsCount;
                        const userPlayer = detGame.totalPaidUser > 0 ? 0 : 1;
                        const valGuestAdd = detGame.pendingGuest + difValGuestAdd + userPlayer;
                        //console.log('Agrega  jugador', { difValGuestAdd, valGuestAdd, userPlayer });
                        setPlayers(valGuestAdd);
                    }
                } else {
                    setPlayers(parseInt(guests) + 1);
                }
            }
        } else {
            setPlayers(parseInt(guests) + 1);
        }
    }, [detGame]);

    useEffect(() => {
        if (players) {
            setDataGame();
        }
    }, [players]);

    useEffect(() => {
        if (dateMatch) {
            setTitle(`${dateMatch.club}`);
        }
    }, [dateMatch]);

    const setDataGame = () => {
        if (detGame && detGame.pricePerPlayer) {
            setDateMatch({
                start: format(new Date(detGame.reservation?.start), "H':'mm"),
                date: format(new Date(detGame.reservation.start), "dd'-'MM'-'Y"),
                end: format(new Date(detGame.reservation.end), "H':'mm"),
                format: detGame.field.format?.name || '',
                club: detGame.field.club?.name || '',
            });
            const time: number = Date.parse(detGame.reservation?.start) - Date.parse(mydate.toString());
            if (time < 0) {
                setTimeGame(true);
            } else {
                setTimeGame(false);
            }
            /*const totalGuests =
                parseInt(guests) === 0
                    ? parseFloat(detGame.pricePerPlayer)
                    : parseFloat(detGame.pricePerPlayer) * players;*/
            if (players > 0) {
                setTotal({
                    ...total,
                    description: `Total a pagar por  ${players} jugador${players > 1 ? 'es' : ''} `,
                    monto: parseFloat(detGame.pricePerPlayer) * players,
                });
            } else {
                setTotal({
                    description: '',
                    monto: 0,
                });
            }
        }
    };

    const handleSubmit = () => {
        setError('');
        const payload = {
            gameId,
            guests: parseInt(guests),
        };
        if (!error) {
            if (detGame && detGame.alreadyJoined && detGame.alreadyJoined === true) {
                dispatch(addGuestGame(payload));
            } else {
                dispatch(joinGame(payload));
            }
        }
    };

    const subTitle = '';

    const back = async () => {
        router.goBack();
    };

    return (
        <Layout navProps={{ title: 'Inscripción | Supermatch', description: 'Inscripción Supermatch' }}>
            <>
                <Header />
                <LayoutInside attribute={attribute} title={title} subTitle={subTitle} breads={breads}>
                    {game.isLoading ? (
                        <Loading />
                    ) : detGame && !status ? (
                        <>
                            {!error && detGame.reservedPlayer && detGame.reservedPlayer ? (
                                <Msj
                                    alreadyJoined={detGame.alreadyJoined ? 'ready' : 'notReady'}
                                    alreadyPaid={
                                        detGame.alreadyPaid && !detGame.alreadyPending ? 'paid_out' : 'pending_to_pay'
                                    }
                                    reservedPlayer={detGame.reservedPlayer}
                                    maxCapacity={detGame.maxCapacity}
                                    guestsCount={detGame.guestsCount}
                                    timeGame={!timeGame ? 'active' : 'inactive'}
                                    totalPaid={detGame.totalPaidUser}
                                    guests={guests}
                                />
                            ) : (
                                ''
                            )}

                            {error && (
                                <div className="flex-col">
                                    <p className="text-center text-2xl italic text-red-500 pt-5 pb-2">{error}</p>
                                </div>
                            )}
                            {!isRedirecting && (
                                <div className="container w-full sm:md:w-5/6 md:w-2/3 mx-auto flex-none md:flex  py-2 md:py-10 mt-2 pl-2 md:px-10 md:space-x-2 border-2 bg-white shadow-lg rounded-xl">
                                    <div className="w-full md:w-1/2">
                                        <PaymentLabels
                                            title="Fecha"
                                            icon="date"
                                            value={`${dateMatch.date}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Desde"
                                            icon="time"
                                            value={`${dateMatch.start} Hrs - ${dateMatch.end} Hrs`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Lugar"
                                            icon="club"
                                            value={`${detGame.field?.club?.name}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Dirección"
                                            icon="location"
                                            value={`${detGame.field?.club?.address}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Cancha"
                                            icon="field"
                                            value={`${detGame.field?.name}`}
                                            sport={sport}
                                        />
                                        {/* <PaymentLabels
                                        title="Formato"
                                        icon="date"
                                        value={`${detGame.field?.format?.name}`}
                                   />*/}
                                        <PaymentLabels
                                            title="Valor"
                                            icon="pay"
                                            value={`${formatPrice(detGame.pricePerPlayer, 0)} por persona`}
                                            sport={sport}
                                        />
                                    </div>
                                    {!timeGame && (
                                        <div className="w-full md:w-1/2 px-2 pt-4 md:pt-0 md:px-0  md:pb-0 ">
                                            <div className="w-full md:w-full text-left ">
                                                <h3 className=" text-center font-bold text-xl text-sm-defy">
                                                    {players === 0
                                                        ? 'Actualiza tu Reserva Eliminaste jugadores que no han pagado'
                                                        : players > 1
                                                        ? 'Total a pagar por ' + players + ' Jugadores'
                                                        : 'Total a pagar por ' + players + ' Jugador'}
                                                </h3>
                                                {/*<h3 className="font-bold text-xl text-sm-defy">{total.description}</h3>
                                            {guests && parseInt(guests) > 0 ? (
                                                <h4 className="text-base text-sm-defy">
                                                    Amigos{' '}
                                                    {detGame.guestsCount && detGame.guestsCount === 0 ? 'actuales' : ''}
                                                    : {guests}
                                                </h4>
                                            ) : (
                                                ''
                                            )}*/}
                                                {/*detGame.paidPlayer && detGame.paidPlayer > 0 ? (
                                                <h4 className="text-base text-sm-defy">
                                                    Jugadores pagos: {detGame.paidPlayer}
                                                </h4>
                                            ) : (
                                                ''
                                            )*/}
                                                {total && total.monto && total.monto > 0 && players > 0 ? (
                                                    <p className="text-4xl pt-6 text-center font-bold italic text-sm-integrate">
                                                        {formatPrice(total.monto, 0)}
                                                    </p>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                            <div className="w-full md:w-full italic text-left text-xl text-white mt-10  p-6 rounded-2xl bg-sm-integrate">
                                                <p>
                                                    Este es el <b>monto</b> que tendrás que pagar cuando la nómina de
                                                    jugadores este completa.
                                                </p>
                                                <p>
                                                    Máximo 2 horas antes del encuentro te{' '}
                                                    <b>confirmaremos el partido por email</b> con link de pago
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            {!timeGame && error === '' && (
                                <div className="flex-col text-center pt-16">
                                    <button
                                        className={`${
                                            (detGame.reservedPlayer &&
                                                detGame.reservedPlayer &&
                                                detGame.reservedPlayer === detGame.maxCapacity) ||
                                            error
                                                ? detGame.alreadyPaid
                                                    ? 'bg-gray-300'
                                                    : 'bg-sm-integrate '
                                                : parseInt(guests) === detGame.guestsCount && detGame.guestsCount !== 0
                                                ? 'bg-gray-300'
                                                : 'bg-sm-integrate '
                                        } w-1/2 md:w-1/4 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                        type="button"
                                        onClick={handleSubmit}
                                        disabled={
                                            (detGame.reservedPlayer &&
                                                detGame.reservedPlayer &&
                                                detGame.reservedPlayer === detGame.maxCapacity) ||
                                            error
                                                ? detGame.alreadyPaid
                                                    ? true
                                                    : false
                                                : isRedirecting
                                                ? true
                                                : parseInt(guests) === detGame.guestsCount && detGame.guestsCount !== 0
                                                ? true
                                                : false
                                        }
                                    >
                                        {game && game.data.data.statusGame === 'CONFIRMED'
                                            ? isRedirecting
                                                ? 'Espera un momento...'
                                                : 'Pagar'
                                            : detGame.guestsCount > 0
                                            ? 'Actualizar Reserva de cupo'
                                            : 'Reservar cupo'}
                                    </button>
                                    {!error && detGame && detGame.reservedPlayer && detGame.reservedPlayer ? (
                                        <Msj
                                            alreadyJoined={detGame.alreadyJoined ? 'ready' : 'notReady'}
                                            reservedPlayer={detGame.reservedPlayer}
                                            maxCapacity={detGame.maxCapacity}
                                            guestsCount={detGame.guestsCount}
                                            guests={guests}
                                        />
                                    ) : (
                                        error && (
                                            <div className="flex-col">
                                                <p className="text-center text-2xl italic text-red-500 pt-5 pb-2">
                                                    {error}
                                                </p>
                                            </div>
                                        )
                                    )}
                                </div>
                            )}
                            {timeGame && (
                                <p className="text-center text-2xl italic text-red-500 pt-5">
                                    La fecha de este partido ya paso
                                </p>
                            )}
                        </>
                    ) : status ? (
                        <MsjSuccess className={'top-0 bg-sm-rent '} classSecondary={'mt-10 md:w-1/4 lg:w-1/3'}>
                            <>
                                <p className="pt-12 text-center text-2xl font-bold italic">
                                    Tu Reserva se ha realizado con éxito
                                </p>
                                <p className="">_________________________</p>
                                <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                    Recuerda que cuando el partido este confirmado te enviaremos un email con el link de
                                    pago.
                                </p>
                                <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                    Tu cupo no está confirmado hasta que sea pagado
                                </p>
                            </>
                        </MsjSuccess>
                    ) : (
                        error && (
                            <div className="flex-col">
                                <div className="text-center text-2xl italic text-red-500 pt-5 pb-2">
                                    {error}
                                    <div className="pt-10 font-bold">
                                        <button
                                            type="button"
                                            className={`w-1/2  text-white px-4 py-4 rounded-lg text-lg mb-6 bg-sm-rent   mt-4`}
                                            onClick={() => back()}
                                        >
                                            {'Volver'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                </LayoutInside>
            </>
        </Layout>
    );
};

export default RegistrationConfirmed;
